import { FeatureFlagEnum, useFeatureFlags } from '@shared/featureManagment';
import { Lock, Login, MonitorMobbile, ProfileCircle, SecuritySafe } from 'iconsax-react';
import { usePathname } from 'next/navigation';
import { useMemo } from 'react';

import { language } from './language';
import { tabRouteKeys, tabRoutes, TabRoutesEnum } from './profileSecurityTypes';

export const useProfileSecurityTabsConfig = (isMobile?: boolean) => {
  const { checkFeature } = useFeatureFlags();
  const pathname = usePathname();
  const isInRoot = pathname === `/${TabRoutesEnum.username}`;
  const activeTab = useMemo(() => {
    const matched = tabRoutes.find((route) => pathname.includes(`/${route}`));
    const route = matched ?? TabRoutesEnum.username;
    return tabRouteKeys[route];
  }, [pathname]);
  const tabsConfig = useMemo(
    () => [
      {
        id: 0,
        key: TabRoutesEnum.username,
        href: isMobile ? `/${TabRoutesEnum.username}/username` : `/${TabRoutesEnum.username}`,
        label: language.username,
        icon: (
          <ProfileCircle size={14} className='hover:text-blue-1 transition-colors text-blue-1' />
        ),
        mobileIcon: (
          <div className='flex h-[34px] w-[34px] items-center justify-center rounded-[6px] bg-pink'>
            <ProfileCircle color='#ffffff' size={18} />
          </div>
        ),
      },
      ...(checkFeature(FeatureFlagEnum.changePasswordEnabled)
        ? [
            {
              id: 1,
              key: TabRoutesEnum.password,
              href: `/${TabRoutesEnum.password}`,
              label: language.password,
              icon: <Lock size={14} className='text-purple hover:text-blue-1' />,
              mobileIcon: (
                <div className='flex h-[34px] w-[34px] items-center justify-center rounded-[6px] bg-purple'>
                  <Lock color='#ffffff' size={18} />
                </div>
              ),
            },
          ]
        : []),
      {
        id: 2,
        key: TabRoutesEnum.twoFA,
        href: `/${TabRoutesEnum.twoFA}`,
        label: language.twoFA,
        icon: <SecuritySafe size={14} className='text-turquoise hover:text-blue-1' />,
        mobileIcon: (
          <div className='flex h-[34px] w-[34px] items-center justify-center rounded-[6px] bg-turquoise'>
            <SecuritySafe color='#ffffff' size={18} />
          </div>
        ),
      },
      {
        id: 3,
        key: TabRoutesEnum.logs,
        href: `/${TabRoutesEnum.logs}`,
        label: language.logs,
        icon: <Login size={14} className='text-orange hover:text-blue-1' />,
        mobileIcon: (
          <div className='flex h-[34px] w-[34px] items-center justify-center rounded-[6px] bg-orange'>
            <Login color='#ffffff' size={18} />
          </div>
        ),
      },
      ...(checkFeature(FeatureFlagEnum.trustedDeviceEnabled)
        ? [
            {
              id: 4,
              key: TabRoutesEnum.trustedDevices,
              href: `/${TabRoutesEnum.trustedDevices}`,
              label: language.trustedDevices,
              icon: (
                <MonitorMobbile size={14} className='text-datePickerBg hover:text-blue-1' />
              ),
              mobileIcon: (
                <div className='flex h-[34px] w-[34px] items-center justify-center rounded-[6px] bg-datePickerBg'>
                  <MonitorMobbile color='#ffffff' size={18} />
                </div>
              ),
            },
          ]
        : []),
    ],
    [checkFeature, isMobile]
  );

  return { tabsConfig, activeTab, isInRoot };
};
